var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voting__header-btn-wrapper"},[_c('a-visibility',{attrs:{"hide":true,"on":[_vm.$breakpoint.mobile, _vm.$breakpoint.tablet]}},[_c('a-header-vote-button',{staticClass:"voting__header-btn"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }